var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.918,44.591c1.104,0,2-0.896,2-2V31.041c0-1.104-0.896-2-2-2H24.082c-1.104,0-2,0.896-2,2v11.551c0,1.104,0.896,2,2,2 c1.879,0,3.409,1.529,3.409,3.409c0,1.879-1.529,3.408-3.409,3.408c-1.104,0-2,0.896-2,2v11.551c0,1.104,0.896,2,2,2h47.836 c1.104,0,2-0.896,2-2V53.408c0-1.104-0.896-2-2-2c-1.879,0-3.408-1.529-3.408-3.408C68.51,46.121,70.039,44.591,71.918,44.591z  M26.082,55.134C29.198,54.26,31.49,51.393,31.49,48s-2.292-6.26-5.409-7.134v-7.825h30.158v29.918H26.082V55.134z M69.918,55.134 v7.825h-9.679V33.041h9.679v7.825C66.802,41.74,64.51,44.607,64.51,48S66.802,54.259,69.918,55.134z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon);
export default __webpack_public_path__ + "static/media/coupon.b3850f06a0951878340ace52f9cfbbd4.svg";
export { ForwardRef as ReactComponent };